import { render, staticRenderFns } from "./global-loaders.vue?vue&type=template&id=28162c37&scoped=true&"
import script from "./global-loaders.vue?vue&type=script&lang=ts&"
export * from "./global-loaders.vue?vue&type=script&lang=ts&"
import style0 from "./global-loaders.vue?vue&type=style&index=0&id=28162c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28162c37",
  null
  
)

export default component.exports